import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import { Avatar } from "../../common/Avatar/Avatar";
import { AvatarSkeleton } from "../../common/Avatar/AvatarSkeleton";
import { IIdentity } from "../../../customTypings/user/Identity";

interface UserProfileHeaderProps {
    user: IIdentity | null;
}

export const UserProfileHeader: React.FC<UserProfileHeaderProps> = ({ user }) => {
    return (
        <>
            <Helmet>
                <title>{`User ${user?.displayName}`}</title>
            </Helmet>

            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/settings" }}>
                    Settings
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/users" }}>
                    Users
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                    {user ? user.displayName : <Skeleton width="6em" />}
                </Breadcrumb.Item>
            </Breadcrumb>

            <Row className="mb-3">
                <h1>
                    {user && <Avatar identity={user} size={1.5} />}
                    {!user && <AvatarSkeleton size={1.5} />}
                </h1>
            </Row>
        </>
    );
};
